<div *ngIf="!dataCourseLoader" malihu-scrollbar class="h-100">
  <p class="d-block d-lg-none notes mb-0">Content
    <a href="javascript:void(0)" (click)="onClose()" class="icon-close tabsClosed"></a>
  </p>
  <ul id="accordionExample" class="contentAccordion courseAccordion">
    <li *ngFor="let module of modules" class="card">
      <div class="card-header" [attr.id]="'heading' + module.moduleNumber">
        <h5 class="mb-0">
          <button class="btn btn-link collapsed" type="button" 
                  data-bs-toggle="collapse" 
                  [attr.data-bs-target]="'#collapse' + module.moduleNumber" 
                  [attr.aria-expanded]="showModule(module)"
                  [attr.aria-controls]="'collapse' + module.moduleNumber">
            <span class="textLabel"><span class="number"></span>{{module?.moduleName}}</span>
            <i class="icon-arrow-down"></i>
            <div *ngIf="isModuleCompleted(module)" class="checkBox tick"></div>
          </button>
        </h5>
      </div>
      <div [attr.id]="'collapse' + module.moduleNumber" class="collapse" [class.show]="showModule(module)"
        [attr.aria-labelledby]="'heading' +module.moduleNumber" data-bs-parent="#accordionExample">
        <div class="card-body">
          <ul class="stepsCheck">
            <li class="success" *ngIf="moduleSetting[module.moduleNumber]" (click)="showModuleOverview(module)"
              [class.current]="_moduleOverview?.show && (_moduleOverview.moduleNumber == module.moduleNumber)">
              <i class="icon-info-circle leftmultiicons"></i>
              <span class="text-label">Module Overview</span>
            </li>
            <li class="success" [class.awaiting-score]="item.mediaType == 'HTML' && !hasScore(item._id)"
              *ngFor="let item of module.contents"
              [class.current]="currentId==item._id && !_moduleOverview?.show" (click)="play(item)">
              <i *ngIf="item.mediaType == 'HTML' || item.type == 'VIA' || item.type?.split('_')[0] == 'ACTIVITY'"
                class="icon-excercise leftmultiicons"></i>
              <i *ngIf="item.mediaType.includes('VIDEO')" class="icon-circleplay leftmultiicons"></i>
              <div [class.checkBox]="hasScore(item._id)" [class.lock]="contentLocked(item?.isForTrail,item?.type)"
                [class.tick]="(completedContents.indexOf(item._id)>-1 && hasScore(item._id)) || (currentCourse?.progress == 100)"
                *ngIf="completedContents.indexOf(item._id)>-1 || contentLocked(item?.isForTrail,item?.type)"></div>
              <span class="text-label">{{item?.title}}</span>
              <div class="optional__tooltip" *ngIf="(item?.mediaType == 'VIDEO') && item?.isNonnugget"><img src="assets/images/icon-feather-info.svg"/>
                <span class="optional__tooltip-text">This is an optional nugget and will not get accounted in the course progress</span>
              </div>
              <span class="timer" *ngIf="!(completedContents.indexOf(item._id)>-1) && !contentLocked(item?.isForTrail,item?.type) &&
                hasScore(item._id)">{{item?.duration | formateSeconds}}</span>
              <span class="awaiting-score__container timer d-flex align-items-center"
                *ngIf="item.mediaType == 'HTML' && !hasScore(item._id) && item.type!='IPJ PRACTICE'">
                <i class="ms-2 icon-awaiting"></i>
                <span class="awaiting-score__popup">Awaiting Score</span>
              </span>
              <span class="awaiting-score__container timer d-flex align-items-center"
                *ngIf="item.mediaType == 'HTML' && !hasScore(item._id) && item.type=='IPJ PRACTICE'">
                <i class="ms-2 icon-awaiting"></i>
                <span class="awaiting-score__popup">Awaiting Feedback</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</div>